module.exports = __webpack_public_path__ + "static/media/acqua.6208d7dc.jpg";